import { Form, InputNumber } from 'antd'
import { TSmartAlertPost } from 'features/automation/types'
import { FC } from 'react'

const SmartListingItem: FC<{
 infoText?: string
 helper?: string
 name: keyof TSmartAlertPost
 label?: string
 subLabel?: string
 input: React.ReactNode
}> = ({ label, subLabel, input, name, helper, infoText }) => {
 return (
  <div className="smart-listing-item">
   <h3>{label}</h3>
   <div className="smart-listing-item-content">
    {subLabel && <div>{subLabel}</div>}
    <Form.Item className="mb-0" name={name}>
     {input}
    </Form.Item>
   </div>
   <div className="smart-listing-item-info">
    <div className="smart-listing-item-info-right">
     {infoText && <div>{infoText}</div>}
    </div>
    {helper && <div className="smart-listing-item-int">{helper}</div>}
   </div>
  </div>
 )
}
export default SmartListingItem
